define.alias("shared/components/shared/ui/video", "media/components/shared/ui/video");